// libraries
import clsx from 'clsx'

// svg
import { Attention } from '/react4xp/components/Icons/Ux'

// css
import './index.scss'

// types
interface ErrorProps {
    label?: string
    className?: string
}

export default function Error({
    label,
    className
}: ErrorProps) {
    return (
        <div className={clsx(
            'error-component red',
            className
        )}>

            <Attention />

            <p className='body-small'>
                {label}
            </p>

        </div>
    )
}